import loadable from '@loadable/component';

export default loadable(
  () => import(/* webpackChunkName: "a-plusContent-dweb" */ './ContentWrapper')
);
